export default {
   intro: ``,
   footer: '[[ {"a":{"href":"https://www.kjrwug.de/de/impressum.php", "title":"Impressum ansehen", "target":"_blank"}} ]]Impressum[[ /a ]] | [[ {"a":{"href":"https://www.kjrwug.de/de/datenschutz.php", "title":"Datenschutz ansehen", "target":"_blank"}} ]]Datenschutz[[ /a ]]',
   approvals: [
      'Ich stimme der Verarbeitung und Speicherung meiner Daten im Rahmen des [[ {"a":{"href":"https://www.kjrwug.de/de/datenschutz.php", "title":"Datenschutz ansehen", "target":"_blank"}} ]]Datenschutzes[[ /a ]] zu.'
   ]
};